import { t as r } from "./to-indexed-object.js";
import { t as e } from "./to-absolute-index.js";
import { l as t } from "./length-of-array-like.js";
var o = function o(_o) {
    return function (n, i, a) {
      var f,
        s = r(n),
        u = t(s),
        l = e(a, u);
      if (_o && i != i) {
        for (; u > l;) if ((f = s[l++]) != f) return !0;
      } else for (; u > l; l++) if ((_o || l in s) && s[l] === i) return _o || l || 0;
      return !_o && -1;
    };
  },
  n = {
    includes: o(!0),
    indexOf: o(!1)
  };
export { n as a };